var css = {"with-badge":"PostingTimeAndPlace-module_with-badge__SAWt7","date-location":"PostingTimeAndPlace-module_date-location__1Owcv"};

export { css as default };
//# sourceMappingURL=PostingTimeAndPlace.module.scss.js.map
